import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { urls } from "../../endPoints";
import { doPost } from "../../../config/fetchWrapper";

export const CreateCustomPlaybookAction = createAsyncThunk(
    "createCustomPlaybook",
    async (arg, { rejectWithValue }) => {
        try {
            const responseData = await doPost(urls?.createCustomPlaybook, arg);
            return responseData;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const createCustomPlaybookSlice = createSlice({
    name: "createCustomPlaybook",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        createCustomPlaybookReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            };
        },
    },
    extraReducers: {
        [CreateCustomPlaybookAction.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = null;
        },
        [CreateCustomPlaybookAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = null;
            state.data = payload;
        },
        [CreateCustomPlaybookAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    },
});

export const { createCustomPlaybookReset } = createCustomPlaybookSlice.actions;
export default createCustomPlaybookSlice.reducer;
